import Menu, {MenuProps} from 'ui-library/menus/Menu';

export const SHARED_MENU_PROPS: Partial<MenuProps> = {
  dropLeft: true,
  height: Menu.HEIGHTS.MEDIUM,
  width: Menu.WIDTHS.LARGE,
};
